import React from 'react';
    import { motion } from 'framer-motion';
    import { Link } from 'react-router-dom';
    import * as FiIcons from 'react-icons/fi';
    import SafeIcon from '../common/SafeIcon';

    const { FiUsers, FiSettings, FiRocket, FiTrendingUp, FiLink, FiCalendar, FiArrowRight } = FiIcons;

    const EcosystemSection = () => {
      const handleLinkClick = () => {
        window.scrollTo(0, 0);
      };

      const handleBookingClick = () => {
        window.open('https://connect.withjahx.com', '_blank');
      };

      const corePathways = [
        {
          icon: FiLink,
          title: 'Link in Bio Pro',
          price: '$33/month',
          description: 'A great foundational business platform. Includes everything in the Clarity Club.',
          features: [
            'Everything in Clarity Club',
            'Branded affiliate link system',
            'Full access to all Prompt Tools',
            'Foundational business tools',
          ],
          popular: true,
          link: '/link-in-bio-pro',
        },
        {
          icon: FiTrendingUp,
          title: 'Growth Pathways',
          price: '$55/month',
          description: 'Choose your own adventure. Specialize in one of six pathways to scale your business.',
          features: [
            'SaaS & Community Building',
            'Brand Bible (Marketing)',
            'Content & Email Automations',
            'SEO & Run Your Business',
            'POD & Pop-up Shops',
          ],
          popular: false,
          link: '/lumadious',
        },
        {
          icon: FiSettings,
          title: 'Lumadious Enterprise',
          price: '$88/month',
          description: 'The ultimate all-in-one solution. Run up to 3 income streams from a single login.',
          features: [
            'Manage 3 income streams',
            'Themed ecosystem for each',
            'Complete business automation',
            '8-week enterprise onboarding',
          ],
          popular: false,
          link: '/lumadious',
        },
      ];

      return (
        <section id="ecosystem" className="py-20 relative">
          <div className="container mx-auto px-6">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="text-center mb-16"
            >
              <h2 className="text-4xl md:text-6xl font-orbitron font-bold mb-6">
                The <span className="clarity-gradient">Ecosystem</span>
              </h2>
              <p className="text-xl text-gray-300 font-poppins max-w-3xl mx-auto">
                Everything you need to transform overwhelm into clarity,chaos into systems,and scattered effort into
                sustainable income.
              </p>
            </motion.div>

            <div className="space-y-12 max-w-5xl mx-auto">
              {/* Step 1: Clarity Club */}
              <motion.div
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
                className="bg-gradient-to-br from-gray-800/50 to-gray-900/50 p-8 rounded-2xl border border-gray-700/50 backdrop-blur-sm"
              >
                <div className="flex flex-col md:flex-row items-center md:space-x-8">
                  <div className="flex-shrink-0 mb-6 md:mb-0">
                    <div className="w-24 h-24 rounded-full bg-gradient-to-r from-green-500 to-emerald-500 flex items-center justify-center">
                      <SafeIcon icon={FiUsers} className="text-white text-4xl" />
                    </div>
                  </div>
                  <div className="flex-grow text-center md:text-left">
                    <h3 className="text-2xl font-orbitron font-bold text-white mb-2">Start Here: Clarity Club (BFCC)</h3>
                    <p className="text-purple-300 font-semibold mb-3">$5.55/mo or $60/yr</p>
                    <p className="text-gray-300 font-poppins mb-4">
                      Best for beginners. Join a supportive community,get weekly training,and start building your
                      foundation.
                    </p>
                  </div>
                  <div className="flex-shrink-0 w-full md:w-auto mt-6 md:mt-0">
                    <a href="https://discord.withjahx.com" target="_blank" rel="noopener noreferrer">
                      <motion.button
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        className="w-full md:w-auto bg-gradient-to-r from-green-600 to-emerald-600 px-8 py-3 rounded-full font-poppins font-semibold text-lg glow-button flex items-center justify-center space-x-2"
                      >
                        <span>Join the Club</span>
                        <SafeIcon icon={FiArrowRight} />
                      </motion.button>
                    </a>
                  </div>
                </div>
              </motion.div>

              {/* Step 2: Discovery Call */}
              <motion.div
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
                className="bg-gradient-to-br from-gray-800/50 to-gray-900/50 p-8 rounded-2xl border border-gray-700/50 backdrop-blur-sm"
              >
                <div className="flex flex-col md:flex-row items-center md:space-x-8">
                  <div className="flex-shrink-0 mb-6 md:mb-0">
                    <div className="w-24 h-24 rounded-full bg-gradient-to-r from-purple-500 to-blue-500 flex items-center justify-center">
                      <SafeIcon icon={FiCalendar} className="text-white text-4xl" />
                    </div>
                  </div>
                  <div className="flex-grow text-center md:text-left">
                    <h3 className="text-2xl font-orbitron font-bold text-white mb-2">Need Guidance? Book a Discovery Call</h3>
                    <p className="text-gray-300 font-poppins mb-4">
                      Feeling lost? Book a free discovery call. We’ll help you choose the right path for your journey.
                      Held on Google Meet or Discord.
                    </p>
                  </div>
                  <div className="flex-shrink-0 w-full md:w-auto mt-6 md:mt-0">
                    <motion.button
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                      onClick={handleBookingClick}
                      className="w-full md:w-auto bg-gradient-to-r from-purple-600/20 to-blue-600/20 border border-purple-500/30 text-purple-300 px-8 py-3 rounded-full font-poppins font-semibold text-lg flex items-center justify-center space-x-2"
                    >
                      <span>Book a Free Call</span>
                    </motion.button>
                  </div>
                </div>
              </motion.div>

              {/* Step 3: Core Pathways */}
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
              >
                <div className="text-center my-12">
                  <h3 className="text-3xl font-orbitron font-bold text-white mb-2">Choose Your Growth Path</h3>
                  <p className="text-gray-300 font-poppins">Select the platform that aligns with your business goals.</p>
                </div>
                <div className="grid md:grid-cols-3 gap-8">
                  {corePathways.map((item, index) => (
                    <motion.div
                      key={index}
                      initial={{ opacity: 0, y: 30 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.6, delay: index * 0.1 }}
                      viewport={{ once: true }}
                      whileHover={{ y: -10 }}
                      className={`relative p-8 rounded-2xl border backdrop-blur-sm transition-all duration-300 flex flex-col ${
                        item.popular
                          ? 'bg-gradient-to-br from-purple-800/60 to-blue-800/60 border-purple-400/50 hover:border-purple-400/70'
                          : 'bg-gradient-to-br from-gray-800/50 to-gray-900/50 border-gray-700/50 hover:border-purple-500/30'
                      }`}
                    >
                      {item.popular && (
                        <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
                          <span className="bg-gradient-to-r from-purple-500 to-blue-500 text-white px-4 py-1 rounded-full text-sm font-poppins font-semibold">
                            Most Popular
                          </span>
                        </div>
                      )}
                      <div className="flex items-center mb-6">
                        <div
                          className={`w-12 h-12 rounded-full flex items-center justify-center mr-4 flex-shrink-0 ${
                            item.popular
                              ? 'bg-gradient-to-r from-purple-400 to-blue-400'
                              : 'bg-gradient-to-r from-purple-500 to-blue-500'
                          }`}
                        >
                          <SafeIcon icon={item.icon} className="text-white text-xl" />
                        </div>
                        <div>
                          <h3 className="text-xl font-orbitron font-bold text-white">{item.title}</h3>
                          <p className={`font-poppins font-semibold ${item.popular ? 'text-purple-200' : 'text-purple-300'}`}>
                            {item.price}
                          </p>
                        </div>
                      </div>
                      <p className="text-gray-300 font-poppins mb-6 text-sm">{item.description}</p>
                      <ul className="space-y-2 mb-6 text-sm">
                        {item.features.map((feature, featureIndex) => (
                          <li key={featureIndex} className="flex items-start text-gray-400 font-poppins">
                            <div
                              className={`w-2 h-2 rounded-full mr-3 mt-1.5 flex-shrink-0 ${
                                item.popular ? 'bg-purple-400' : 'bg-purple-500'
                              }`}
                            ></div>
                            {feature}
                          </li>
                        ))}
                      </ul>
                      <div className="mt-auto">
                        <Link to={item.link} onClick={handleLinkClick}>
                          <motion.button
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            className={`w-full py-3 rounded-full font-poppins font-medium transition-all duration-300 ${
                              item.popular
                                ? 'bg-gradient-to-r from-purple-500 to-blue-500 text-white glow-button hover:from-purple-600 hover:to-blue-600'
                                : 'bg-gradient-to-r from-purple-600/20 to-blue-600/20 border border-purple-500/30 text-purple-300 hover:from-purple-600/40 hover:to-blue-600/40'
                            }`}
                          >
                            {item.popular ? 'Get Started' : 'Learn More'}
                          </motion.button>
                        </Link>
                      </div>
                    </motion.div>
                  ))}
                </div>
              </motion.div>

              {/* Step 4: Launch Kits */}
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
                className="!mt-20"
              >
                <div className="bg-gradient-to-br from-gray-800/50 to-gray-900/50 p-8 rounded-2xl border border-gray-700/50 backdrop-blur-sm">
                  <div className="flex flex-col md:flex-row items-center text-center md:text-left md:space-x-8">
                    <div className="flex-shrink-0 mb-6 md:mb-0">
                      <div className="w-24 h-24 rounded-full bg-gradient-to-r from-orange-500 to-red-500 flex items-center justify-center">
                        <SafeIcon icon={FiRocket} className="text-white text-4xl" />
                      </div>
                    </div>
                    <div className="flex-grow">
                      <h3 className="text-2xl font-orbitron font-bold text-white mb-2">Accelerate Your Success with Launch Kits</h3>
                      <p className="text-gray-300 font-poppins mb-4">
                        Need to go live fast? Go from idea to income in 48 hours with our proven templates for
                        funnels,emails,and pages.
                      </p>
                    </div>
                    <div className="flex-shrink-0 w-full md:w-auto mt-6 md:mt-0">
                      <Link to="/launch-kits" onClick={handleLinkClick}>
                        <motion.button
                          whileHover={{ scale: 1.05 }}
                          whileTap={{ scale: 0.95 }}
                          className="w-full md:w-auto bg-gradient-to-r from-orange-600 to-red-600 px-8 py-3 rounded-full font-poppins font-semibold text-lg glow-button flex items-center justify-center space-x-2"
                        >
                          <span>Explore Kits</span>
                          <SafeIcon icon={FiArrowRight} />
                        </motion.button>
                      </Link>
                    </div>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </section>
      );
    };

    export default EcosystemSection;